import { Grid, Icon, Link, Text, useIsDesignLanguage, DesignLanguage, useIsTheme, Theme } from '@afterpaytouch/core'
import React, { FC } from 'react'
import { Trans, useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'
import { Wrapper } from '../Wrapper'
import styles from './style.module.css'
import { useCountry } from '../../state'
import { Country } from '@afterpay/types'

interface Props {
  clickHandler: () => void
}

export const ResendInstructions: FC<Props> = ({ clickHandler }) => {
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { t } = useTranslation()
  const { textSize } = useCheckoutSizes()
  const isCashTheme = useIsTheme(Theme.Cash)
  const country = useCountry()
  const textColor = isCashTheme ? 'Subtle' : undefined
  if (isArcadeDesignLanguage && country === Country.US) {
    return (
      <>
        <Wrapper>
          <Grid>
            <Text size={textSize} color={textColor}>
              <Trans
                i18nKey={'passwordResetRequired:sendAgain'}
                components={{
                  a: <Link onClick={clickHandler} kind={'Underline'} color='Prominent' />,
                }}
              />
            </Text>
          </Grid>
        </Wrapper>
        <div className={styles.spacer}></div>
      </>
    )
  }

  return (
    <>
      <Wrapper>
        <Grid>
          <Text size={textSize} bold>
            {t('passwordResetRequired:secondaryBody')}
          </Text>
        </Grid>
      </Wrapper>
      <Grid>
        <Text size={textSize}>
          <Icon.Trash />
          <span className={styles.ml4}>{t('passwordResetRequired:trash')}</span>
        </Text>
      </Grid>
      <Wrapper>
        <Grid>
          <Text size={textSize}>
            <Icon.Email />
            <span className={styles.ml4}>
              <Trans
                i18nKey={'passwordResetRequired:sendAgain'}
                components={{
                  a: <Link onClick={clickHandler} kind={'Underline'} />,
                }}
              />
            </span>
          </Text>
        </Grid>
      </Wrapper>
      <div className={styles.mt8}></div>
    </>
  )
}
